var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 79,
    viewBox: "0 0 140 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9641_877",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 79
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 78.2609,
    rx: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9641_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.348 82.6086C138.6 82.6086 158.261 62.948 158.261 38.6955C158.261 14.443 138.6 -5.21753 114.348 -5.21753C90.0951 -5.21753 70.4346 14.443 70.4346 38.6955C70.4346 46.0317 72.2335 52.9477 75.4144 59.0265",
    stroke: "#FFC61B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.087 75.4934C76.087 64.3476 82.174 63.0432 82.174 56.9563C82.174 50.8693 83.3647 47.8259 85.2175 47.8259C89.1306 47.826 88.6965 51.4318 88.6958 53.9128C88.6948 57.4654 87.3355 62.4586 90.0001 64.3478C93.4783 67.826 99.5653 66.0869 108.696 65.2173C110.979 64.9999 115.664 64.3955 117.391 64.3478C120.294 64.2676 122.174 65.0365 122.174 66.9565C122.174 67.826 121.689 68.9024 120 69.5652C115.577 71.3004 110.341 71.5041 105.652 72.1739C106.377 72.4637 107.478 73.7391 107.826 76.5217",
    stroke: "#ECB600",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.481 34.342C137.391 38.4086 134.129 40.5814 131.536 39.8866C128.943 39.1918 127.204 35.6789 128.294 31.6123C129.383 27.5457 132.646 25.3729 135.239 26.0677C137.832 26.7626 139.571 30.2754 138.481 34.342Z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6324 22.6579C99.7978 18.3085 103.456 15.5095 106.802 16.4063C110.149 17.303 111.917 21.5558 110.752 25.9053C109.586 30.2547 105.928 33.0537 102.582 32.157C100.658 31.6414 99.2554 30.0166 98.6324 27.9019",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.174 13.913C106.522 6.52165 98.058 7.52751 93.9133 11.3043",
    stroke: "#7F39FA",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.174 20.7939C141.111 18.2024 147.324 24.0373 148.417 29.5372",
    stroke: "#7F39FA",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.87 51.2288C110 51.2288 117.826 53.0433 126.087 59.5651",
    stroke: "#7F39FA",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9641_877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 137.5,
    height: 75.7609,
    rx: 6.75,
    stroke: "#C7AAFA",
    strokeWidth: 2.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9641_877",
    x: -11,
    y: -11,
    width: 162,
    height: 100.261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_9641_877"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.780392 0 0 0 0 0.666667 0 0 0 0 0.980392 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9641_877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9641_877",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/think.f740faa875f71364dd8f2d198db78577.svg";